import AppHeader from '../AppHeader'

export default {
  name: 'master-supplier-list',
  created () {
    this.getSupplier()
  },
  data () {
    return {
      suppliers: '',
      supplierName: '',
      searchCallbackFlag: true
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    async getSupplier () {
      let data = {
        'supplierName': this.supplierName
      }
      let res = await this.$store.dispatch('GET_SUPPLIER_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.suppliers = res.suppliers
      this.searchCallbackFlag = true
    },
    goSupplierDetail (supplierId) {
      this.$router.push({path: `/master_supplier/${supplierId}`})
    },
    goSupplierNew () {
      this.$router.push({path: '/master_supplier/new'})
    },
    goSupplierEdit (supplierId) {
      this.$router.push({path: `/master_supplier/${supplierId}/edit`})
    },
    async supplierDelete (supplierId) {
      if (!window.confirm('このサプライヤーを削除しますか？')) {
        return
      }

      // 該当サプライヤーの消耗品が登録されているか確認
      let res = await this.$store.dispatch('GET_SUPPLIER_PRODUCTS', {id: supplierId, data: {}})
      .catch(err => {
        console.log(err)
        return
      })

      if (res.exist) {
        window.alert('このサプライヤーの消耗品が登録されています。\n該当の消耗品を削除してください。')
      } else {
        await this.$store.dispatch('DELETE_SUPPLIER', {id: supplierId, data: {}})
        .catch(err => {
          console.log(err)
          return
        })
        this.getSupplier()
      }
    },
    setOrderMethod (orderMethod) {
      if (orderMethod == 'fax') {
        return 'FAX'
      } else if (orderMethod == 'email') {
        return 'email'
      } else {
        return 'たのめーる'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-supplier-list.js